import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { LogoMark } from "@/components/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const ref = localStorage.getItem("hh_ref");
        const url = ref ? `/auth/google/session?ref=${encodeURIComponent(ref)}` : "/auth/google/session";
        const { data } = await api.post(url, {}, { headers: { "X-Session-ID": sessionId } });
        localStorage.removeItem("hh_ref");
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/campus", { state: { user: data.user } });
      } catch {
        navigate("/login");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#0B0E14] flex flex-col items-center justify-center gap-4 text-slate-400">
      <div className="h-11 w-11 animate-pulse">
        <LogoMark size={44} />
      </div>
      Signing you in…
    </div>
  );
}
